import React from "react";
import { Box, Typography, Button, Paper } from "@mui/material";
import { useNavigate } from "react-router-dom";

const NotFound: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Box
      sx={{
        minHeight: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        bgcolor: "#f7f8fa",
        textAlign: "center",
        px: 2,
      }}
    >
      <Paper elevation={6} sx={{ p: 5, borderRadius: 6, maxWidth: 480, bgcolor: "#fff" }}>
        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center" }}>
          {/* Illustration: You can replace src with your own SVG or PNG */}
          <img
            src="https://cdn.dribbble.com/users/285475/screenshots/2083086/dribbble_1.gif"
            alt="404 illustration"
            style={{ width: 120, marginBottom: 24 }}
          />
          <Typography variant="h2" color="error" fontWeight={700} sx={{ mb: 1 }}>
            404
          </Typography>
          <Typography variant="h5" fontWeight={600} sx={{ mb: 2 }}>
            Oops! Page Not Found
          </Typography>
          <Typography variant="body1" color="text.secondary" sx={{ mb: 3 }}>
            Hey explorer! Looks like you’re heading to a wrong planet.<br />
            The page you’re looking for doesn’t exist or has been moved.
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            sx={{ textTransform: "none", fontWeight: 600 }}
            onClick={() => navigate("/dashboard")}
          >
            Take me back to Homepage
          </Button>
        </Box>
      </Paper>
    </Box>
  );
};

export default NotFound;